module.exports = __webpack_public_path__ + "img/default-bg-th.f4bb7704.png";